<div class="flex h-full flex-column md:flex-row" aria-busy="true">
  <div
    class="surface-0 pt-5 pb-3 h-full flex flex-column gap-3 flex-grow-1 surface-border border-right-1 md:max-w-23rem w-full">
    <div class="px-4 flex flex-column gap-3">
      <div class="surface-border border-1 border-round-xl surface-0 p-4 w-max">
        <p-skeleton width="12rem" height="8rem" borderRadius="0.75rem" />
      </div>

      <div class="flex flex-column gap-2 mb-5">
        <p-skeleton width="16rem" height="1.75rem" />
        <p-skeleton width="10rem" height="1.75rem" />
      </div>

      @for (action of actions; track action) {
        <div
          class="surface-border border-1 pl-4 pr-2 py-2 w-full md:w-20rem flex align-items-center gap-3 border-round">
          <p-skeleton
            [width]="action === 0 ? '4rem' : '5.5rem'"
            height="1.1rem" />
          <p-skeleton class="ml-auto" shape="circle" size="3rem" />
        </div>
      }
    </div>

    <footer class="mt-auto flex flex-column gap-3">
      <div class="px-4 flex gap-3">
        <p-skeleton width="9rem" height="2.5rem" borderRadius="2rem" />
        <p-skeleton class="ml-auto" shape="circle" size="2.5rem" />
        <p-skeleton shape="circle" size="2.5rem" />
      </div>

      <div class="w-full px-4 py-3 border-top-1 border-bottom-1 surface-border">
        <p-skeleton width="20rem" height="7rem" styleClass="max-w-full" />
      </div>
      <div class="flex gap-3 px-4">
        <p-skeleton width="4.5rem" height="0.9rem" />
        <p-skeleton width="5.5rem" height="0.9rem" />
      </div>
    </footer>
  </div>

  <div class="surface-ground w-full overflow-hidden">
    <div class="grid p-3 w-full">
      @for (tile of tiles; track $index) {
        <div
          class="md:col-6 col-12 flex tile"
          [ngClass]="tile.spotlight ? 'xl:col-8' : 'xl:col-4'"
          [style.animation-delay]="$index * 60 + 'ms'">
          <div
            class="p-4 p-card flex flex-grow-1 flex-column gap-2 border-round-xl">
            <header class="flex align-items-center gap-3 mb-2">
              <p-skeleton
                class="flex-grow-1"
                [width]="tile.spotlight ? '45%' : '60%'"
                height="1.75rem" />
              <p-skeleton class="ml-auto" size="3rem" borderRadius="0.75rem" />
            </header>
            @for (line of tile.lines; track $index) {
              <p-skeleton [width]="line" height="0.9rem" />
            }
            <footer class="mt-auto pt-3">
              <p-skeleton width="10rem" height="2.5rem" borderRadius="2rem" />
            </footer>
          </div>
        </div>
      }
    </div>
  </div>
</div>
